var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ueditor-textarea"},[_c('textarea',{ref:"simditaor",attrs:{"id":_vm.editorId,"placeholder":"请输入详细信息"}})])}
var staticRenderFns = []

export { render, staticRenderFns }